import { useAtomValue } from 'jotai';

import type { AuthState } from '../../contracts';
import { authStateAtom } from '../atoms';

/**
 * Reactive subscription to the cache's coarse-grained auth state.
 * Returns one of `'loading' | 'authenticated' | 'unauthenticated'`.
 *
 * Use this when a component needs to render differently per state
 * (e.g. show a skeleton while loading, the login page while
 * unauthenticated, the app while authenticated). For the boolean
 * shortcut, prefer `useIsAuthenticated().isAuthenticated`.
 */
export function useAuthState(): AuthState {
  return useAtomValue(authStateAtom);
}
